<template>
    <span
    class="text-primary">
    <i
        class="fa fa-edit fa-lg icon-button mr-1"
        title="Atualizar"
        @click.stop="atualizarPleito()"
    ></i>
    </span>
</template>

<script>
export default {
    props: {
        pleito: {
            type: Object,
            default: () => ({}) 
        },
        pleitosServicos: {
            type: Object,
            default: () => ({}) 
        },
        rotaListagem: {
            type: String,
        },
        rotaAtualizar: {
            type: String,
        }
    },
   
    methods: {
        atualizarPleito() {
            this.$router.push({
                name: this.rotaAtualizar,
                params: {
                    pleitoId: this.pleito.pleitoId,
                    pleitosServicos: this.pleitosServicos,
                    rotaListagem: this.rotaListagem
                }
            })
        }
    }
}
</script>